export default __webpack_public_path__ + "static/media/HP-OLDLogoMain.4aee1cf4.png";